import React, { useState, useEffect } from 'react';
import BiteListChart from './BiteListChart';
import ExpandedBiteCountryRow from './BiteList/ExpandedBiteCountryRow';
import ExpandedPEPListRow from './PEP/ExpandedPEPListRow';
import ExpandedDebarredRow from './Debarred/ExpandedDebarredRow';
import CircularProgress from '@mui/material/CircularProgress';

interface IBiteListUpperProps {
  countryData: any;
  selectedIndex: string;
  handleScroll: any;
}

const BiteListUpper: React.FC<IBiteListUpperProps> = ({
  selectedIndex,
  countryData,
  handleScroll,
}) => {
  const [ total, setTotal ] = useState(0);

  useEffect(() => {
    const countryTotals: number[] = [];
    if (selectedIndex === 'Risk Insights') {
      countryData.data.countryAgg.buckets.map((country: any) => {
        countryTotals.push(country.doc_count);
      });
      const countryTotal = countryTotals.reduce(
        (accum: number, cur: number) => {
          return accum + cur;
        },
        0,
      );
      setTotal(countryTotal);
    }
    if (selectedIndex === 'PEP') {
      countryData.data.countryAgg.buckets.map((country: any) => {
        countryTotals.push(country.doc_count);
      });
      const countryTotal = countryTotals.reduce(
        (accum: number, cur: number) => {
          return accum + cur;
        },
        0,
      );
      setTotal(countryTotal);
    }
    if (selectedIndex === 'Debarred') {
      if (countryData.data.countryAgg.buckets) {
        countryData.data.countryAgg.buckets.map((govtAgency: any) => {
          countryTotals.push(govtAgency.doc_count);
        });
        const countryTotal = countryTotals.reduce(
          (accum: number, cur: number) => {
            return accum + cur;
          },
          0,
        );
        setTotal(countryTotal);
      }
    }
    if (selectedIndex === 'FF Labor' || selectedIndex === 'ESG Registrations') {
      if (countryData.data.countryAgg.buckets) {
        countryData.data.countryAgg.buckets.map((govtAgency: any) => {
          countryTotals.push(govtAgency.doc_count);
        });
        const countryTotal = countryTotals.reduce(
          (accum: number, cur: number) => {
            return accum + cur;
          },
          0,
        );
        setTotal(countryTotal);
      }
    }
  }, [ selectedIndex, countryData ]);

  return (
    <>
      <div className='denied-sources'>
        <div className='ds-header'>
          <div className='ds-header-text'>Data Sources</div>
          <div className='ds-header-text-records' onClick={handleScroll}>
            View Detailed Records
          </div>
        </div>
        <>
          <div className='ds-table-top'>
            <div className='ds-table-space'></div>
            <div className='ds-table-col'>
              <div className='ds-table-col-header'>
                <div className='ds-col-title'>Source</div>
              </div>
            </div>
            <div className='ds-table-col-end'>
              <div className='ds-table-col-header'>
                <div className='ds-col-title'>Records</div>
              </div>
            </div>
          </div>
          <div className='ds-table'>
            {selectedIndex === 'Risk Insights' &&
              countryData.data.countryAgg.buckets &&
              countryData.data.countryAgg.buckets.map(
                (country: any, index: number) => (
                  <ExpandedBiteCountryRow key={index} data={country} />
                ),
              )}
            {selectedIndex === 'PEP' &&
              countryData.data.countryAgg.buckets &&
              countryData.data.countryAgg.buckets.map(
                (country: any, index: number) => (
                  <ExpandedPEPListRow key={index} data={country} />
                ),
              )}
            {selectedIndex === 'Debarred' &&
              countryData.data.countryAgg.buckets &&
              countryData.data.countryAgg.buckets.map(
                (govtAgency: any, index: number) => (
                  <ExpandedDebarredRow key={index} data={govtAgency} />
                ),
              )}
            {(selectedIndex === 'FF Labor' ||
              selectedIndex === 'ESG Registrations') &&
              countryData.data.countryAgg.buckets &&
              countryData.data.countryAgg.buckets.map(
                (govtAgency: any, index: number) => (
                  <ExpandedDebarredRow key={index} data={govtAgency} />
                ),
              )}
          </div>
          <div className='ds-footer'>
            <div className='ds-foot-text'>Total</div>
            <div className='ds-total'>{total.toLocaleString()}</div>
          </div>
        </>
      </div>
      <div className='country-breakdown'>
        <div className='cb-header'>
          <div className='cb-header-text'>Source Breakdown</div>
        </div>
        {countryData.isLoading ? (
          <div>
            <CircularProgress style={{ color: '#0E8BFF' }} />
          </div>
        ) : (
          <BiteListChart
            selectedIndex={selectedIndex}
            countryData={countryData}
          />
        )}
      </div>
    </>
  );
};

export default BiteListUpper;
